<div class="sidenav__menu sticky-top">
    <div *ngFor="let menu of menus" id="menu{{ menu.IdMenu }}" class="sidenav__item" routerLinkActive="sidenav--active">
        <a routerLink="../{{ menu.ComponentName }}">
            <div class="sidenav__item--icon">
                <img src="{{ menu.ImgSrc }}" alt="{{ menu.Descripcion }}">
            </div>
        </a>
        <div class="sidenav__item--text">
            <a routerLink="../{{ menu.ComponentName }}">{{ menu.Descripcion }}</a>
        </div>
    </div>
</div>
